import Index from '@/views/site/Index';
import auth from '../middleware/auth';
import manager from '../middleware/manager';
import requiresPasswordChange from '../middleware/user-password-change';

// Routes
// Te liekam vnk visu, kas iet zem /
// Vajadzētu būt ok, tik jāliek klāt middleware, atkarībā kādu vajag. Katram route.
import categoryRoutes from './category-routes';
import companyRoutes from './company-routes';
import userRoutes from './user-routes';
import documentRoutes from './document-routes';
import {ovpRoutes, companyOvpRoutes} from './ovp-routes';

export default {
    path: '/',
    name: 'index',
    meta: {
        middleware: [auth, requiresPasswordChange],
    },
    component: Index,
    children: [
        {
            path: 'uznemums',
            name: 'company-profile',
            meta: {
                middleware: [auth, manager, requiresPasswordChange],
            },
            component: () => import('@/views/site/Company'),
        },
        {
            path: 'kategorijas',
            name: 'company-statistics',
            meta: {
                middleware: [auth, manager, requiresPasswordChange],
            },
            component: () => import('@/views/site/CompanyCategories'),
        },
        // {
        //     path: 'ovp',
        //     name: 'view-company-ovp-job-conditions',
        //     meta: {
        //         middleware: [auth, manager],
        //     },
        //     component: () => import('@/components/ovp/CompanyOvpJobConditions'),
        // },
        categoryRoutes,
        companyRoutes,
        ...userRoutes,
        documentRoutes,
        ...companyOvpRoutes,
        ovpRoutes,
    ]
}